"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _ProgressBar = _interopRequireDefault(require("./ProgressBar.sizes"));

var _styles = require("./styles");

var _excluded = ["percentage", "subtitle", "size"];

var ProgressBar = function ProgressBar(_ref) {
  var percentage = _ref.percentage,
      subtitle = _ref.subtitle,
      size = _ref.size,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var ProgressBarSize = _ProgressBar.default[size];
  return /*#__PURE__*/_react.default.createElement(_styles.Container, rest, /*#__PURE__*/_react.default.createElement(_styles.StepContainer, null, /*#__PURE__*/_react.default.createElement(_styles.StepBar, {
    percentage: percentage,
    size: ProgressBarSize
  })), subtitle && /*#__PURE__*/_react.default.createElement(_styles.Subtitle, null, subtitle));
};

ProgressBar.defaultProps = {
  percentage: 0,
  size: 'sm'
};

var _default = (0, _styledComponents.withTheme)(ProgressBar);

exports.default = _default;